// @flow

import React, {Component} from 'react';
import {touch, isValid, getFormValues} from 'redux-form';
import {connect} from 'react-redux';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import {
  fetchAdditionalProducts,
  fetchAdditionalVariants,
} from '../../actions/productView';
import ModalDialog from '../../components/ModalDialog/ModalDialog';
import LinkedAdditionalVariantForm from '../../components/LinkedAdditionalVariantForm/LinkedAdditionalVariantForm';
import validator from '../../helpers/validator';
import _ from 'lodash/fp';
import AdminList from '../../components/AdminList/AdminList';

const additionalValidation = {
  product: {rule: 'required', label: 'Produkt'},
  productVariant: {rule: 'required', label: 'Variant'},
  quantity: {rule: 'numeric|min:0|required', label: 'Antal'},
};

const additionalColumns = [{
  property: 'productVariant.name',
  header: {
    label: 'Variant',
  },
}, {
  property: 'product.name',
  header: {
    label: 'Produkt',
  },
}, {
  property: 'quantity',
  header: {
    label: 'Antal',
  },
}, {
  property: 'note',
  header: {
    label: 'Kommentar',
  },
}];

export type Props = {
  setActive: Function,
  fetchAdditionalProducts: Function,
  fetchAdditionalVariants: Function,
  active: any,
  variants: any[],
  products: any[],
  existing: any[],
  variantsIsFetching: boolean,
  productsIsFetching: boolean,
  addAdditional: Function,
  updateAdditional: Function,
  removeAdditional: Function,
  additionalFormValues: any,
  additionalFormIsValid: boolean,
  touch: typeof touch,
};

class LinkedAdditionalVariantsContainer extends Component<Props> {
  props: Props;

  handleSelectProductId = id => {
    this.props.fetchAdditionalVariants(id);
  }

  closeDialog() {
    this.props.setActive(null);
  }

  onOpenDialog() {
    this.props.fetchAdditionalProducts();
  }

  save() {
    const {
      active,
      touch,
      additionalFormValues,
      additionalFormIsValid,
      addAdditional,
      updateAdditional,
    } = this.props;
    const keys = _.keys(additionalValidation);
    touch('linkedAdditionalVariant', ...keys);

    if (!additionalFormIsValid) {
      return;
    }

    if (!active.productVariant) {
      addAdditional(additionalFormValues);
    } else {
      updateAdditional(additionalFormValues);
    }

    this.closeDialog();
  }

  remove(additional) {
    this.props.removeAdditional(additional);
    this.closeDialog();
  }

  render() {
    const {
      active,
      products,
      variants,
      variantsIsFetching,
      productsIsFetching,
      existing,
      setActive,
    } = this.props;

    return (
      <div className="LinkedAdditionalVariantsContainer">
        <AdminList
          rowKey={({rowData}) => rowData.productVariant.id}
          onRowSelected={row => setActive(row)}
          columns={additionalColumns}
          rows={existing} />
        <button
          onClick={() => setActive({})}
          type="button"
          className="button small">
          Lägg till tilläggsprodukt
        </button>
        <ModalDialog
          onClose={() => this.closeDialog()}
          onOpen={() => this.onOpenDialog()}
          show={!!active}>
          <LoadingIndicator
            isLoading={
              variantsIsFetching ||
              productsIsFetching
            } />
          <LinkedAdditionalVariantForm
            initialValues={active}
            editing={!!active && !!active.productVariant}
            existing={existing}
            products={products}
            variants={variants}
            onSelectProduct={this.handleSelectProductId}
            validate={values => validator(additionalValidation, values)}
          />
          <button
            type="button"
            className="expanded button"
            onClick={() => this.save()}>
              Spara
          </button>
          {active && active.productVariant &&
            <button
              type="button"
              className="expanded warning button"
              onClick={() => this.remove(active)}>
                Ta bort
            </button>
          }
          <button
            type="button"
            className="expanded button"
            onClick={() => this.closeDialog()}>
              Stäng
          </button>
        </ModalDialog>
      </div>
    );
  }
}

const mapStateToProps = ({
  productView: {
    linkedAdditionalVariantDialog: {
      products: {
        isFetching: productsIsFetching,
        list: products,
      },
      variants: {
        isFetching: variantsIsFetching,
        list: variants,
      },
    },
  },
  form,
}) => ({
  variants,
  products,
  variantsIsFetching,
  productsIsFetching,
  additionalFormIsValid: isValid('linkedAdditionalVariant')({form}),
  additionalFormValues: getFormValues('linkedAdditionalVariant')({form}),
});

const mapDispatchToProps = dispatch => ({
  fetchAdditionalProducts: () =>
    dispatch(fetchAdditionalProducts()),
  fetchAdditionalVariants: id =>
    dispatch(fetchAdditionalVariants(id)),
  touch: (form, ...fields) =>
    dispatch(touch(form, ...fields)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LinkedAdditionalVariantsContainer);



// WEBPACK FOOTER //
// ./src/containers/LinkedAdditionalVariantsContainer/LinkedAdditionalVariantsContainer.js